// extracted by mini-css-extract-plugin
export var arrow = "side-nav-module--arrow--35b12";
export var back = "side-nav-module--back--83d35";
export var container = "side-nav-module--container--718d3";
export var filterWrap = "side-nav-module--filterWrap--c8c7a";
export var noResults = "side-nav-module--noResults--f104e";
export var noResultsSubTitle = "side-nav-module--noResultsSubTitle--69912";
export var noResultsTitle = "side-nav-module--noResultsTitle--2e62c";